<style scoped>
@import "./style.css";
</style>

<script>
export default {
  name: "BgTypography",
  bind: (el, binding) => {
    const isArray = Array.isArray(binding.value);
    const classes = isArray ? binding.value : [binding.value];

    el.classList.add("bg-typography");
    classes.forEach((c) => el.classList.add(`bg-typography--${c}`));
  },
};
</script>
